export const isFilterShown = (state, getters) => state.showFilter
export const getFilter = (state, getters) => state.filter
